import { ApolloClient, InMemoryCache, HttpLink } from 'apollo-boost';
import { onError } from 'apollo-link-error';
import { setContext } from 'apollo-link-context';
import { includes } from 'lodash';
import history from '../../utils/history';
import config from '../../config';

// Inicializar caché
const cache = new InMemoryCache();

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'network-only',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  },
};

const httpLink = new HttpLink({
  uri: config.api.graphql,
  credentials: 'same-origin',
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.map(({ message, locations, path }) => {
      console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`); // eslint-disable-line
      if (includes(message, 'JWT')) {
        localStorage.removeItem('user');
        localStorage.removeItem('jwt');
        history.push('/');
      }
      return false;
    });
  }
  if (networkError) {
    console.log(`[Network error]: ${networkError}`); // eslint-disable-line
  }
});

const authLink = setContext(async (req, { headers }) => {
  const token = localStorage.getItem('jwt');
  const header = token ? { authorization: `Bearer ${token}` } : {};
  return {
    ...headers,
    headers: header,
  };
});

const link = errorLink.concat(authLink.concat(httpLink));

const apolloClient = new ApolloClient({
  connectToDevTools: process.browser,
  ssrMode: !process.browser,
  link,
  cache,
  defaultOptions,
});

export default apolloClient;
